import {ComponentLoader} from './component-loader/ComponentLoader';

export default new ComponentLoader({
    componentSelector: '[data-webpack-component]',
    componentDatasetName: 'webpackComponent',
});
